const images: { [key: string]: HTMLImageElement } = {}
const imagePromises = new Map<string, Promise<HTMLImageElement>>();

export function loadImage(src: string): Promise<HTMLImageElement> {
	if (!src || src.endsWith("icons/")) {
		return Promise.reject(new Error(`Invalid image src: ${src}`));
	}
	const cached = images[src];
	if (cached?.complete) return Promise.resolve(cached);

	let pending = imagePromises.get(src);
	if (pending) return pending;

	pending = new Promise<HTMLImageElement>((resolve, reject) => {
		const img = images[src] ?? new Image();
		images[src] = img;
		img.addEventListener("load", () => { imagePromises.delete(src); resolve(img); }, { once: true });
		img.addEventListener("error", () => { imagePromises.delete(src); delete images[src]; reject(new Error(`Failed to load: ${src}`)); }, { once: true });
		if (img.src !== src) img.src = src;
	});
	imagePromises.set(src, pending);
	return pending;
}

export function rasterImage(img: HTMLImageElement, width: number, height: number): HTMLCanvasElement | HTMLImageElement {
	if (img.src.endsWith("svg")) {
		const canvas = document.createElement('canvas');
		canvas.width = width;
		canvas.height = height;
		const context = canvas.getContext('2d') as CanvasRenderingContext2D;
		context.imageSmoothingQuality = "high";
		context.drawImage(img, 0, 0, width, height);
		return canvas;
	} else {
		return img
	}
}